import { InjectionToken } from '@angular/core';
import { type Observable } from 'rxjs';

import {
  type ColumnId,
  type ComparisonOperator,
  type ComparisonQueryNode,
  type DisplayInfo,
  type LogicalType,
} from '@blaze-shared/api-contracts-domain';
import { type IntelliConfig } from '@blaze-shared/intellisense-feature';
import { type ColumnFieldOption } from '@blaze-shared/schema-domain';
import { type SelectOption } from '@blaze-shared/shared-util';
import { type LegacyWorkflowError } from '@blaze-shared/workflow-domain';

export const FLOATING_FILTERS_SERVICE = new InjectionToken('FLOATING_FILTERS_SERVICE');

export interface FilterCondition {
  column: string;
  description?: string;
  displayInfos?: DisplayInfo[];
  isFormulaValue: boolean;
  operator: ComparisonOperator;
  original?: ComparisonQueryNode;
  value?: string;
}

export abstract class FloatingFiltersService {
  abstract columns$: Observable<SelectOption<ColumnId | string | ColumnFieldOption>[]>;
  abstract operators$: Observable<SelectOption<ComparisonOperator>[]>;
  abstract intelliConfig$: Observable<IntelliConfig>;

  abstract get closeReturnValue(): any;

  abstract onConditionChange(condition: Partial<FilterCondition>): void;
  abstract onConditionWorkflowErrorsChange(workflowErrors: LegacyWorkflowError[]): void;
  abstract saveCondition(condition: FilterCondition): Observable<any>;
  abstract removeCondition(condition: ComparisonQueryNode): Observable<any>;
  abstract updateQueryLogicalType(logicalType: LogicalType): Observable<any>;
}
